module.exports = __webpack_public_path__ + "static/media/closeIcon.139baf9c.svg";